import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=39067dab&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=39067dab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39067dab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39067dab')) {
      api.createRecord('39067dab', component.options)
    } else {
      api.reload('39067dab', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=39067dab&scoped=true&", function () {
      api.rerender('39067dab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Z88rdiB0J6i/JS/comp/SearchFilterTokens.vue"
export default component.exports